import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { IoChatbubbleEllipsesOutline, IoCloseSharp } from "react-icons/io5";
import {
  commercialHeadGetAllFacilities, commercialHeadGetContracts, commercialHeadGetDraftContracts,
  commercialHeadGetAllMeters, facmanGetUnassignedMeters, facmanGetAssignedMeters,
  commercialHeadGetAllFacilitiesForNav, commercialHeadGetContractsForDropdown, commercialHeadGetFMSContracts,
  commercialHeadGetContractsForDropdownTechnician, facilityManagerGetAllAssets,
  getChatList
} from "../../Redux/Actions/Actions";
import { IoSettingsOutline } from "react-icons/io5";
import axios from '../../axios-interceptor';
import { base_url, wss_url } from '../../utilities';
import Loader from './loader';
import { set } from 'date-fns';
import { Button, Modal } from 'react-bootstrap';
import { MdErrorOutline } from 'react-icons/md';
import { RECORDS_PER_PAGE } from '../../Config';
import { APP_BASE_MOD } from '../../Config';
import { encrypt, timeElapsed } from './ReusableFunctions';
import CryptoJS from "crypto-js";
import Chat from './Chat';
import { PiBellLight } from "react-icons/pi";
import { PiChatCircleTextLight } from "react-icons/pi";
import { LuMenu } from "react-icons/lu";
import { FaRegCircleUser } from "react-icons/fa6";
import LeftNavBar from './LeftNavBar';
import { Drawer } from '@mui/material';

export default function NavBarTop() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const [menuActive, setMenuActive] = useState(false)
  const [showProfile, setShowProfile] = useState(false)
  const facilitiesList = useSelector(state => state.facilitiesListForNav)
  const unreadChatList = useSelector(state => state.unreadChatList)
  const [isPaused, setPause] = useState(false);
  const [unreadChatArray, setUnreadChatArray] = useState([])

  const [cityFacilities, setCityFacilities] = useState({});
  const [selectedCityName, setSelectedCityName] = useState("")
  const [selectedFacilityId, setSelectedFacilityId] = useState("")
  const [facilitiesForDropdown, setFacilitiesForDropdown] = useState([])
  const [logoutError, setLogoutError] = useState(null)
  const [socketNotification, setSocketNotification] = useState(null)
  const [unreadMessageCount, setUnreadMessageCount] = useState(0)
  const [userId, setUserId] = useState(localStorage.getItem('user_id'))

  const [selectedEnvBase, setSelectedEnvBase] = useState()


  const [viewChat, setViewChat] = useState(false)
  const [notifacationIconClicked, setNotificationIconClicked] = useState(false)
  const [unredNotificationCount, setUnreadNotificationCount] = useState(0)
  const [userNotificationsColor, setUserNotificationsColor] = useState({
    "contract": "#33FF57",
    "invoice": "#FF5733",
    "meter": "#3357FF",
    "event": "#FF33A1",
    "asset": "#FF8C33",
    "payment": "#FF33B5",
    "issue": "#FF5733",
    "facility": "#FF8653",
  })

  const [userNotifications, setUserNotifications] = useState([
  ])

  const notificationsDummy = [
    {
      "recipient_id": "55df8665-72f7-46f2-8e53-9fda7c465aee",
      "notification_id": "addbffa2-c45d-4d98-bdfe-02b4af295577",
      "user_id": "716e4316-3f97-49bc-bdf0-7cfa2385c6d9",
      "user_name": "ceo_persona",
      "persona": "CEO",
      "is_read": 0,
      "read_at": null,
      "created_at": "2025-04-09 10:56:08",
      "updated_at": "2025-04-09 10:56:08",
      "created_by": "",
      "updated_by": "",
      "notification_id_1": "addbffa2-c45d-4d98-bdfe-02b4af295577",
      "notification_type": "ContractCreated",
      "service": "Customers",
      "message": "A new contract SpaceHub1 has been created Facility-main1 facility.",
      "entity_type": "FMS Contract",
      "entity_id": "3e46efeb-6a29-4520-a27e-4425d327003e",
      "facility_name": "Facility-main1",
      "facility_id": "76da955c-be2f-48da-8536-919756131cd0",
      "notification_route": "/commercialHeadFMSContracts",
      "created_at_1": "2025-04-09 10:56:08",
      "updated_at_1": "2025-04-09 10:56:08",
      "created_by_1": "",
      "updated_by_1": ""
    },
    {
      "recipient_id": "55df8665-72f7-46f2-8e53-9fda7c465aee",
      "notification_id": "addbffa2-c45d-4d98-bdfe-02b4af295577",
      "user_id": "716e4316-3f97-49bc-bdf0-7cfa2385c6d9",
      "user_name": "ceo_persona",
      "persona": "CEO",
      "is_read": 0,
      "read_at": null,
      "created_at": "2025-04-09 10:56:08",
      "updated_at": "2025-04-09 10:56:08",
      "created_by": "",
      "updated_by": "",
      "notification_id_1": "addbffa2-c45d-4d98-bdfe-02b4af295577",
      "notification_type": "ContractCreated",
      "service": "Customers",
      "message": "A new issues has been raised Facility-main1 facility.",
      "entity_type": "Issue",
      "entity_id": "5637460d-d09d-4daf-b23a-4a0bab2a64af",
      "facility_name": "Facility-main1",
      "facility_id": "76da955c-be2f-48da-8536-919756131cd0",
      "notification_route": "/issuesAndIncidents",
      "created_at_1": "2025-04-09 10:56:08",
      "updated_at_1": "2025-04-09 10:56:08",
      "created_by_1": "",
      "updated_by_1": ""
    },
    {
      "recipient_id": "55df8665-72f7-46f2-8e53-9fda7c465aee",
      "notification_id": "addbffa2-c45d-4d98-bdfe-02b4af295577",
      "user_id": "716e4316-3f97-49bc-bdf0-7cfa2385c6d9",
      "user_name": "ceo_persona",
      "persona": "CEO",
      "is_read": 0,
      "read_at": null,
      "created_at": "2025-04-09 10:56:08",
      "updated_at": "2025-04-09 10:56:08",
      "created_by": "",
      "updated_by": "",
      "notification_id_1": "addbffa2-c45d-4d98-bdfe-02b4af295577",
      "notification_type": "ContractCreated",
      "service": "Customers",
      "message": "A Asset named Asset_8ce3f39f has been created in Facility-main1 facility.",
      "entity_type": "Asset",
      "entity_id": "ba428b29-9be9-4595-931a-515347ef3c2a",
      "facility_name": "Facility-main1",
      "facility_id": "76da955c-be2f-48da-8536-919756131cd0",
      "notification_route": "/FacilityManagerAssetsList",
      "created_at_1": "2025-04-09 10:56:08",
      "updated_at_1": "2025-04-09 10:56:08",
      "created_by_1": "",
      "updated_by_1": ""
    }, {
      "recipient_id": "55df8665-72f7-46f2-8e53-9fda7c465aee",
      "notification_id": "addbffa2-c45d-4d98-bdfe-02b4af295577",
      "user_id": "716e4316-3f97-49bc-bdf0-7cfa2385c6d9",
      "user_name": "ceo_persona",
      "persona": "CEO",
      "is_read": 0,
      "read_at": null,
      "created_at": "2025-04-09 10:56:08",
      "updated_at": "2025-04-09 10:56:08",
      "created_by": "",
      "updated_by": "",
      "notification_id_1": "addbffa2-c45d-4d98-bdfe-02b4af295577",
      "notification_type": "ContractCreated",
      "service": "Customers",
      "message": "You have a new payment for Facility-main1 facility.",
      "entity_type": "Payment",
      "entity_id": "eef47728-9d95-489b-a92d-c4205a5047a8",
      "facility_name": "Facility-main1",
      "facility_id": "76da955c-be2f-48da-8536-919756131cd0",
      "notification_route": "/financeManagerPayments",
      "created_at_1": "2025-04-09 10:56:08",
      "updated_at_1": "2025-04-09 10:56:08",
      "created_by_1": "",
      "updated_by_1": ""
    },
  ]

  useEffect(() => {
    let totalUnreadCount = 0
    unreadChatList?.forEach(chat => {
      if (chat.unread_count > 0) {
        totalUnreadCount = totalUnreadCount + 1
      }
    })
    setUnreadMessageCount(totalUnreadCount)
    setUnreadChatArray(unreadChatList)
  }, [unreadChatList])




  // aws websocket integration
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const socketRef = useRef(null);
  const user_token = localStorage.getItem('access_token');
  const [audio, setAudio] = useState(null);

  const playSound = () => {
    if (audio) {
      audio.play().catch(err => console.error("Playback failed:", err));
    }
  };


  useEffect(() => {
    const enableAudio = () => {
      const newAudio = new Audio('/notification.wav');
      setAudio(newAudio); // Store audio instance for later use

      document.removeEventListener("click", enableAudio);
      document.removeEventListener("keydown", enableAudio);
    };

    document.addEventListener("click", enableAudio);
    document.addEventListener("keydown", enableAudio);

    return () => {
      document.removeEventListener("click", enableAudio);
      document.removeEventListener("keydown", enableAudio);
    };
  }, []);




  useEffect(() => {
    const secretKey = "PortOSKey";
    const encryptedToken = encryptToken(user_token, secretKey);
    const socketUrl = `${wss_url}?token=${encodeURIComponent(encryptedToken)}`;
    socketRef.current = new WebSocket(socketUrl);

    socketRef.current.onopen = () => {
      setIsConnected(true);
      console.log("WebSocket connection opened");
    };

    socketRef.current.onclose = () => {
      setIsConnected(false);
      console.log("WebSocket connection closed");
      // Optionally reconnect to the socket
      // setTimeout(() => {
      //   connectWebSocket();
      // }, 1000);
    };

    socketRef.current.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    const wsCurrent = socketRef.current;

    return () => {
      wsCurrent.close();
    };
  }, []);

  useEffect(() => {
    if (!viewChat) {
      if (!socketRef.current) return;
      socketRef.current.onmessage = async (e) => {
        if (isPaused) return;
        const message = JSON.parse(e.data);
        if (message?.message_type === 'new_message') {
          // find the chat in the unreadChatArray
          let chat = unreadChatArray.find(chat => chat.chat_group_id === message.chat_group_id)
          if (chat?.unread_count > 0) {
            chat.unread_count = chat.unread_count + 1
          } else {
            chat.unread_count = 1
            setUnreadMessageCount(prev => prev + 1)
          }

          let chatIndex = unreadChatArray.findIndex(chat => chat.chat_group_id === message.chat_group_id)
          unreadChatArray[chatIndex] = chat
          setUnreadChatArray([...unreadChatArray])
          // const audio = new Audio('/notification.wav'); // Adjust path if needed
          // audio.play();
          playSound();
        };
      }
    }
  }, [socketRef, unreadChatArray]);

  const encryptToken = (token, secretKey) => {
    // return CryptoJS.AES.encrypt(token, secretKey).toString();
    return token;
  };

  const notificationClicked = () => {
    if (socketRef.current?.readyState === WebSocket.OPEN) {
      const username = localStorage.getItem("username")
      let toName = ''
      toName = username === 'facman_persona' ? 'ceo_persona' : 'facman_persona'
      socketRef.current.send(JSON.stringify({ action: "sendMessage", 'message': `Hello from ${username}`, 'message_body': `Hello from ${username}`, to: toName }));
    } else {
      console.error("WebSocket is not open. Cannot send message.");
    }
  }

  useEffect(() => {
    if (socketNotification) {
      sendNotification(socketNotification);
      setSocketNotification(null)
    }
  }, [socketNotification]);

  useEffect(() => {
    // Initial connection setup
    // connectWebSocket();

    // Cleanup on component unmount
    return () => {
      socketRef.current?.close();
    };
  }, []);


  // POC for push notifcation

  const requestNotificationPermission = async () => {
    if (Notification.permission === 'default') {
      await Notification.requestPermission();
    }
  };


  const sendNotification = (data, url) => {
    // Check if the current device is iOS
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isIOS) {
      return;
    }

    if (Notification.permission === 'granted') {
      const notification = new Notification("Notification", {
        body: data,
        icon: './images/icons/loginimage.jpg',
      });

      // Add click event to the notification
      notification.onclick = () => {
        // Redirect to the desired URL
        window.open(base_url, '_blank'); // Open in a new tab
        notification.close(); // Close the notification
      };
    } else {
      console.log('Notification permission is not granted');
    }
  };


  useEffect(() => {
    requestNotificationPermission();
  }, []);


  const groupName = localStorage.getItem("group");
  const handleProfileNavigation = () =>{
    if(groupName === "Customer"){
      navigate('/customerProfile')
    }
    else if(groupName === "CEO"){
      navigate('/OrganizationProfile')
    }
  }

  const getCurrentEnvironment = () => {
    const currentUrl = base_url;
    for (const ev in APP_BASE_MOD) {
      if (currentUrl.includes(ev)) {
        setSelectedEnvBase(APP_BASE_MOD[ev]);
      }
    }
  };

  const getEnvironmentIndicator = (environment) => {
    switch (environment) {
      case 'Dev':
        return <span className="environment-indicator blue"></span>;
      case 'QA':
        return <span className="environment-indicator orange"></span>;
      case 'UAT':
        return <span className="environment-indicator purple"></span>;
      case 'Live':
        return <span className="environment-indicator green"></span>;
      default:
        return null;
    }
  };

  const getNotificationFromBackend = () => {
    const userId = localStorage.getItem("user_id")
    axios.get(base_url + `notifications`, {
      params: {
        request_type: "dropdown",
        filter_condition: JSON.stringify({
          user_id: userId,
          is_read: 0,
        })
      }
    })
      .then((res) => {
        if (res.status === 200) {
          const response = res.data.data
          const numberofNotifications = response.length
          // response.push(...notificationsDummy)
          // console.log(notificationsDummy)
          setUserNotifications(res.data.data)
          setUnreadNotificationCount(numberofNotifications)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const updateNotificationStatus = (notification) => {
    const username = localStorage.getItem("username")
    const body = {
      "recipient_id": notification?.recipient_id,
      "is_read": 1,
      "read_at": new Date(),
      "updated_by": username,
    }
    axios.put(base_url + `notifications`, body)
      .then((res) => {
        if (res.status === 200) {
          setUnreadNotificationCount(unredNotificationCount > 0 ? unredNotificationCount - 1 : 0)
          navigate(notification?.notification_route, { state: { props: notification } })
        }
      })
      .catch((err) => {
        console.log(err)
      })

  }

  useEffect(() => {
    getCurrentEnvironment();
    // updateNotificationStatus("fd76c5e0-3c28-4345-9969-59a77165d38c")
    getNotificationFromBackend();
    const intervalId = setInterval(() => {
      getNotificationFromBackend();
    }, 300000); // 300000ms = 5 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
    dispatch(getChatList(userId))
  }, [dispatch]);

  useEffect(() => {
    dispatch(commercialHeadGetAllFacilitiesForNav());
  }, [dispatch])

  useEffect(() => {

    const cityFacilities = {};
    facilitiesList?.forEach(facility => {
      const { city, name, facility_id } = facility;
      if (cityFacilities[city]) {
        cityFacilities[city].push({ name: name, facility_id: facility_id });
      } else {
        if (localStorage.getItem("selected_city_name") === "") {
          localStorage.setItem("selected_city_name", city)
          localStorage.setItem("selected_facility_id", facility_id)
          localStorage.setItem("selected_facility_name", name)
          // If path is commercial head users
          if (window.location.pathname === "/commercialHeadContracts") {
            dispatch(commercialHeadGetContracts({ facility_id: facility_id, status: 'active', search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));
            dispatch(commercialHeadGetDraftContracts({ facility_id: facility_id, search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));
            dispatch(commercialHeadGetAllMeters(
              {
                request_type: "dropdown",
                filter_condition: {
                  facility_id: facility_id,
                  is_in_use: 0,
                  is_working: 1
                }
              }
            ));
          }
          if (window.location.pathname === "/commercialHeadFMSContracts") {
            dispatch(commercialHeadGetFMSContracts({ facility_id: facility_id, status: "active", search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));
          }
          // If path is electricity technician meter readings
          if (window.location.pathname === "/electricityMeterReadings") {
            dispatch(commercialHeadGetContractsForDropdownTechnician({ facility_id: facility_id }));
          }

          if (window.location.pathname === "/waterMeterReadings") {
            dispatch(commercialHeadGetContractsForDropdownTechnician({ facility_id: facility_id }));
          }

          if (window.location.pathname === "/FacilityManagerMeterMaster") {
            dispatch(facmanGetUnassignedMeters(
              {
                search_text: "",
                items_per_page: RECORDS_PER_PAGE,
                page_number: 1,
                filter_condition: {
                  facility_id: facility_id,
                  is_in_use: 0,
                  is_working: 1
                }
              }
            ));

            dispatch(facmanGetAssignedMeters({
              search_text: "",
              items_per_page: RECORDS_PER_PAGE,
              page_number: 1,
              filter_condition: {
                facility_id: facility_id
              }
            }
            ))

            dispatch(facilityManagerGetAllAssets({ facility_id: facility_id, search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }))
          }
        }
        cityFacilities[city] = [{ name: name, facility_id: facility_id }];
      }
    });
    Object.keys(cityFacilities).forEach(city => {
      cityFacilities[city].sort((a, b) => a.name.localeCompare(b.name));
    });
    if (localStorage.getItem("selected_city_name") !== "") {
      setFacilitiesForDropdown(cityFacilities[localStorage.getItem("selected_city_name")])
    }
    setCityFacilities(cityFacilities);
  }, [dispatch, facilitiesList])

  const handleLogout = () => {
    setLoading(true)
    axios.post(base_url + "authorization/logout", encrypt({ username: localStorage.getItem("username") }))
      .then((res) => {
        if (res.status === 200) {
          localStorage.clear();
          navigate("/", { replace: true })
          setLoading(false)
        }
      })
      .catch((err) => {
        setLogoutError(err?.response?.data?.message)
        setLoading(false)
      })
  }

  const handleCityChange = (e) => {
    const cityValue = e.target.value;
    setSelectedCityName(cityValue);
    localStorage.setItem("selected_city_name", cityValue)
    localStorage.setItem("selected_facility_id", cityFacilities[cityValue][0].facility_id)
    localStorage.setItem("selected_facility_name", cityFacilities[cityValue][0].name)
    if (window.location.pathname === "/commercialHeadContracts") {
      dispatch(commercialHeadGetContracts({ facility_id: cityFacilities[cityValue][0].facility_id, status: 'active', search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));
      dispatch(commercialHeadGetDraftContracts({ facility_id: cityFacilities[cityValue][0].facility_id, search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));

      dispatch(commercialHeadGetAllMeters(
        {
          request_type: "dropdown",
          filter_condition: {
            facility_id: cityFacilities[cityValue][0].facility_id,
            is_in_use: 0,
            is_working: 1
          }
        }
      ));
    }

    if (window.location.pathname === "/commercialHeadFMSContracts") {
      dispatch(commercialHeadGetFMSContracts({ facility_id: cityFacilities[cityValue][0].facility_id, status: "active", search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));
    }

    if (window.location.pathname === "/electricityMeterReadings") {
      dispatch(commercialHeadGetContractsForDropdownTechnician({ facility_id: cityFacilities[cityValue][0].facility_id }));
    }

    if (window.location.pathname === "/waterMeterReadings") {
      dispatch(commercialHeadGetContractsForDropdownTechnician({ facility_id: cityFacilities[cityValue][0].facility_id }));
    }

    if (window.location.pathname === "/FacilityManagerMeterMaster") {
      dispatch(facmanGetUnassignedMeters(
        {
          search_text: "",
          items_per_page: RECORDS_PER_PAGE,
          page_number: 1,
          filter_condition: {
            facility_id: cityFacilities[cityValue][0].facility_id,
            is_in_use: 0,
            is_working: 1
          }
        }
      ));

      dispatch(facmanGetAssignedMeters({
        search_text: "",
        items_per_page: RECORDS_PER_PAGE,
        page_number: 1,
        filter_condition: {
          facility_id: cityFacilities[cityValue][0].facility_id
        }
      }
      ))

      dispatch(facilityManagerGetAllAssets({ facility_id: cityFacilities[cityValue][0].facility_id, search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }))
    }

    setFacilitiesForDropdown(cityFacilities[cityValue])

    window.location.reload();

  }

  const handleFacilityChange = (e) => {
    const facilityId = e.target.value;

    const selectedIndex = e.target.selectedIndex;
    const facilityName = e.target.options[selectedIndex].text;
    setSelectedFacilityId(facilityId);
    localStorage.setItem("selected_facility_id", facilityId)
    localStorage.setItem("selected_facility_name", facilityName)
    if (window.location.pathname === "/commercialHeadContracts") {
      dispatch(commercialHeadGetContracts({ facility_id: facilityId, status: 'active', search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));
      dispatch(commercialHeadGetDraftContracts({ facility_id: facilityId, search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));

      dispatch(commercialHeadGetAllMeters(
        {
          request_type: "dropdown",
          filter_condition: {
            facility_id: facilityId,
            is_in_use: 0,
            is_working: 1
          }
        }
      ));
    }
    if (window.location.pathname === "/commercialHeadFMSContracts") {
      dispatch(commercialHeadGetFMSContracts({ facility_id: facilityId, status: "active", search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }));
    }
    if (window.location.pathname === "/electricityMeterReadings") {
      dispatch(commercialHeadGetContractsForDropdownTechnician({ facility_id: facilityId }));
    }

    if (window.location.pathname === "/waterMeterReadings") {
      dispatch(commercialHeadGetContractsForDropdownTechnician({ facility_id: facilityId }));
    }

    if (window.location.pathname === "/FacilityManagerMeterMaster") {
      dispatch(facmanGetUnassignedMeters(
        {
          search_text: "",
          items_per_page: RECORDS_PER_PAGE,
          page_number: 1,
          filter_condition: {
            facility_id: facilityId,
            is_in_use: 0,
            is_working: 1
          }
        }
      ));

      dispatch(facmanGetAssignedMeters({
        search_text: "",
        items_per_page: RECORDS_PER_PAGE,
        page_number: 1,
        filter_condition: {
          facility_id: facilityId
        }
      }
      ))

      dispatch(facilityManagerGetAllAssets({ facility_id: facilityId, search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }))

    }
    window.location.reload();
  }
  // const environment = getCurrentEnvironment();

  const toggleDrawer = () => {
    setMenuActive((prevState) => !prevState)
  }

  return (
    <>
      {loading && <Loader />}
      {logoutError && <Modal keyboard={false} backdrop="static" show={logoutError} onHide={() => {
        setLogoutError(null)
      }} centered className="popper-modal">
        <Modal.Body className="text-center">
          <MdErrorOutline style={{ fontWeight: "10px", fontSize: "60px", color: "#Cc0202", opacity: 0.8 }} />
          <h5>Error!</h5>
          <p className="mb-3">{logoutError}</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center" >
          <Button variant="secondary" className="secondary" onClick={() => {
            setLogoutError(null)
          }} >
            Close
          </Button>
        </Modal.Footer>
      </Modal>}
      <div className={(selectedEnvBase?.name === "Dev") ? 'topNavBarDev' : ((selectedEnvBase?.name === "QA") ? 'topNavBarQa'
        : (selectedEnvBase?.name === 'UAT') ? 'topNavBarUat' : 'topNavBar')} style={{ zIndex: 9999 }}>
        <div className='topNavItems'>
          <LuMenu className='icon-navbar menuIcon mobile-menu-btn' alt=""
            onClick={() => setMenuActive(!menuActive)}
          />
        </div>
        <div className='topNavIcons'>
          {/* <IoChatbubbleEllipsesOutline className='topNavIcon C-pointer'
            onClick={()=>{
              navigate('/chat')
            }}
          /> */}
          {/* <div className='C-pointer' style={{ position: 'relative' }}>

            <div className='d-flex'>
              <img src="./images/icons/payments.svg"
                style={{ width: '32px' }}
                alt="Organization-Payments" className='C-pointer' onClick={() => {
                  navigate('/organizationPayments')
                }}
              />
            </div>
          </div> */}

          <div className='C-pointer' style={{ position: 'relative' }}>

            <div className='d-flex'>
              <PiBellLight size={35}
                className="icon-navbar"
                onClick={() => {
                  // notificationClicked()
                  setNotificationIconClicked(!notifacationIconClicked)
                }} />
              {unredNotificationCount !== 0 && <p
                style={{
                  background: 'green',
                  color: 'white',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  padding: '2px',
                  textAlign: 'center',
                  fontSize: '12px',
                  marginLeft: '-16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // marginTop: '5px'
                }}
              >{unredNotificationCount > 9 ? "9+" : unredNotificationCount}</p>}
            </div>
            {notifacationIconClicked &&
              <div style={{
                background: 'white',
                // overflowY: 'scroll',
                // textAlign: 'center',
                padding: '10px',
                fontSize: '12px',
                marginLeft: '-70px',
                borderRadius: '5px',
                marginTop: '5px',
                position: 'absolute',
                border: '1px solid #ccc',

              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row', padding: '5px' }}>
                  <span style={{ fontSize: "20px", fontWeight: "600" }}>Notifications</span>
                  <IoCloseSharp style={{
                    width: '20px',
                    height: '20px',
                    // marginTop: '5px',
                    marginRight: '5px'
                  }}
                    className='C-pointer' onClick={() => setNotificationIconClicked(false)} />
                  {/* <img src="./images/icons/close.svg"
                    
                    alt="close"  /> */}
                </div>
                <hr style={{ marginTop: "2px", }}></hr>
                <div className='notification-list' style={{
                  width: '350px',
                  height: '200px',
                  overflowY: 'scroll',
                }}>
                  {userNotifications?.length === 0 && <div style={{ textAlign: 'center', padding: '10px', color: 'gray' }}>No new notifications</div>}
                  {userNotifications?.map((notification) => {
                    return <div className='notification-item C-pointer' key={notification.id}
                      style={{ padding: '5px' }}
                      onClick={() => {
                        setNotificationIconClicked(false)
                        updateNotificationStatus(notification)
                      }}>
                      <div className='d-flex justify-content-between align-items-center'>
                        <div className='d-flex justify-content-start align-items-center gap-1'>
                          <div style={{
                            backgroundColor: userNotificationsColor[notification?.entity_type.toLowerCase()],
                            width: '7px',
                            height: '7px',
                            borderRadius: '50%',
                          }} />

                          <h2 style={{ fontSize: '12px', margin: '0px' }}>{notification?.entity_type}</h2>
                        </div>
                        <div style={{ fontSize: '12px', color: '#888' }}>{timeElapsed(notification?.created_at)}</div>
                      </div>
                      <div className='notification-message' style={{ fontSize: '14px', color: 'gray' }}>
                        {notification.message}
                      </div>
                    </div>
                  })}

                </div>
                <p
                  onClick={() => {
                    setNotificationIconClicked(false)
                    navigate("/notificationLogs")
                  }}
                  className='C-pointer'
                  style={{
                    textAlign: 'center',
                    color: '#007BFF',
                    width: '100%',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    marginTop: '10px',
                    padding: '5px',
                    cursor: 'pointer',
                    backgroundColor: '#d9f0ff',
                    margin: '0px',
                  }}
                >View All</p>
              </div>}
          </div>


          <div className='d-flex'>
            <PiChatCircleTextLight size={35} alt="Chat" className='C-pointer icon-navbar' onClick={() => {
              setViewChat(!viewChat)
            }} />
            {unreadMessageCount !== 0 && <p
              style={{
                background: 'green',
                color: 'white',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                textAlign: 'center',
                fontSize: '12px',
                marginLeft: '-16px',
                // marginTop: '33px'
              }}
            >{unreadMessageCount}</p>}
          </div>
          {
            selectedEnvBase &&
            <div className='environment-indicator-container'>
              <div className='env-name'>
                <p> {localStorage?.getItem("group")}</p>
              </div>
              <div className={`${selectedEnvBase.bgcolor} env-bar`}>
                <span>
                  {getEnvironmentIndicator(selectedEnvBase?.name)}
                </span>
                <span>
                  {selectedEnvBase?.name}
                </span>
              </div>
            </div>

          }



          {localStorage.getItem("username") ? <div className='d-flex flex-column mr-1'>
            <span className='profile-icon C-pointer' onMouseOver={() => setShowProfile(true)} onClick={() => setShowProfile(!showProfile)}>{localStorage?.getItem("name")[0]?.toUpperCase()}</span>
            {showProfile &&
              <div className='profile-relative-container' onMouseLeave={() => setShowProfile(false)}>
                <div className='triangle'>

                </div>
                <div className='profile-container d-flex  align-items-start'>
                  <div>
                    <div className='d-flex flex-column justify-content-end gap-2'>

                      <div className='d-flex align-items-start justify-content-between profile-info' style={{ width: '100%' }}>
                        <h5 style={{ margin: 0 }}>{localStorage?.getItem("name")}</h5>
                      </div>
                      <div >{localStorage?.getItem("email")}</div>

                    </div>
                  </div>
                  <hr style={{ width: '100%', margin: '0' }} />
                  {/* <div>
                    <div className='d-flex flex-column profile-items-container '>
                      <div className='C-pointer '>
                        <div className='d-flex gap-2  align-items-center profile-items w-100 mx-auto' onClick={() => {
                          handleProfileNavigation()
                        }}>
                          {localStorage?.getItem("group") === "CEO" ? (
                            <>
                              <IoSettingsOutline style={{ width: '20px', height: '20px' }} />
                              <p style={{ marginBottom: '0', fontSize: '14px' }}>Organization Profile</p>
                            </>
                          ) : null}
                          {localStorage?.getItem("group") === "Customer" ? (
                            <>
                              <FaRegCircleUser style={{ width: '20px', height: '20px' }} />
                              <p style={{ marginBottom: '0', fontSize: '14px' }}>Profile</p>
                            </>
                          ) : null}
                        </div>

                      </div>
                    </div>
                  </div>
                  {(localStorage?.getItem("group") === "CEO" || localStorage?.getItem("group") === "Customer") && <hr style={{ width: '100%', margin: '0' }} />} */}
                  <button
                    className='btn btn-primary logout-button w-100 mx-auto'
                    style={{ display: 'block' }}
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </div>
              </div>}
          </div> : <img src="./images/icons/useruser.svg" alt=""
            className="topNavIcon"
          />}
        </div>
      </div>

      {/* {menuActive &&
        <>
          {
            window.location.pathname !== "/commercialHeadAddFacility" && window.location.pathname !== "/users" ?
              <>
                <div className='responsive_top_navbar'>

                  <div className='responsiveTopNavFilters'>
                    <select className='topNavdropdown' value={localStorage.getItem("selected_city_name")} onChange={(e) => handleCityChange(e)}>
                      {cityFacilities && Object.keys(cityFacilities).sort((a, b) => a.localeCompare(b)).map(city => {
                        return <option value={city}>{city}</option>
                      })}
                    </select>
                  </div>
                  <div className='responsiveTopNavFilters'>
                    <select value={localStorage.getItem("selected_facility_id")} className='topNavdropdown'
                      onChange={(e) => handleFacilityChange(e)}
                    >
                      {
                        facilitiesForDropdown && facilitiesForDropdown?.map(facility => {
                          return <option value={facility.facility_id}>{facility.name}</option>

                        })
                      }
                    </select>
                  </div>
                </div>

              </> : null
          }
        </>
      } */}
      {viewChat && <div className={`chat-box ${viewChat ? 'open' : 'closed'}`}
        style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
      >
        <Chat
          setViewChat={setViewChat}
          ws={socketRef}
          webSocketConnection={isConnected}
          setUnreadMessageCount={setUnreadMessageCount}
          unreadChatArray={unreadChatArray}
          setUnreadChatArray={setUnreadChatArray}
        />
      </div>}

      <Drawer
        open={menuActive}
        onClose={toggleDrawer}
        direction='left'
        className='navbar-drawer'
        style={{}}
      >
        <div style={{ marginTop: "10vh" }}>
          {/* <div style={{ overflowX: "auto", height: "70vh" }}> */}
          <LeftNavBar  menuActive={menuActive} />
          {/* </div> */}
        </div>
      </Drawer>
    </>
  )
}
